module.exports = __webpack_public_path__ + "img/no-items.a878ded4.svg";